import axios from 'axios'
import store from '@/store'
import { refresh } from '@/apis/user';
import { mockVenuesList, mockServiceAddResponse, mockServiceUpdateResponse, mockServiceDetailResponse, mockServiceListResponse } from '../mock';

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000,
});

const MOCK_MODE = process.env.VUE_APP_MOCK === 'true';

const mockRoutes = {
    'GET /api/service': () => mockServiceListResponse,
    'GET /api/service/:id': () => mockServiceDetailResponse,
    'POST /api/service': () => mockServiceAddResponse,
    'PUT /api/service/:id': () => mockServiceUpdateResponse,
    'GET /api/venues': () => mockVenuesList,
};

const getMockResponse = (method, url) => {
    const key = `${method.toUpperCase()} ${url}`;
    if (mockRoutes[key]) {
        return mockRoutes[key]();
    }
    for (const routeKey of Object.keys(mockRoutes)) {
        if (routeKey.includes(':id') && key.startsWith(routeKey.split(':id')[0])) {
            return mockRoutes[routeKey]();
        }
    }
    return null;
};

// 當前是否正在刷新 token 的標誌
let isRefreshing = false

// 待重試請求隊列
let requestsQueue = []



service.interceptors.request.use(
    config => {
        if (MOCK_MODE) {
            const mockResponse = getMockResponse(config.method, config.url);
            if (mockResponse) {
                console.log('[MOCK]', config.method.toUpperCase(), config.url, config.data);
                return Promise.reject({
                    mockResponse,
                    config
                });
            }
        }
        config.noAuth = config.noAuth == undefined ? false : config.noAuth;
        if (!config.noAuth) {
            const token = store.state.token
            if (token) {
                config.headers['iToken'] = `${token}`;
            }
        }
        return config;
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// 響應攔截器 (處理 token 過期)
service.interceptors.response.use(
    //response => response,
    async response => {
        const { config, data } = response;
        return Promise.resolve(data);
    },
    async error => {
        if (MOCK_MODE && error.mockResponse) {
            console.log('[MOCK RESPONSE]', error.mockResponse);
            return Promise.resolve(error.mockResponse);
        }
        const { config, response } = error
        const originalRequest = config
        if (!config.noAuth || (response && response.status === 401 && !originalRequest._retry)) {
            originalRequest._retry = true;
            if (response && response.status === 401) {
                store.dispatch('logout')
            }
            return Promise.reject(error);



            //如果正在刷新，將請求加入隊列等待
            // if (isRefreshing) {
            //     return new Promise(resolve => {
            //         requestsQueue.push(() => resolve(service(originalRequest)))
            //     })
            // }

            // isRefreshing = true;

            // try {
            //     // 請求刷新API
            //     const { data } = await refresh(store.state.refreshToken);

            //     // 更新存儲中的 token
            //     const newToken = data.accessToken
            //     store.commit('UPDATE_TOKEN', newToken)

            //     // 重放所有隊列中的請求
            //     requestsQueue.forEach(cb => cb(newToken))
            //     requestsQueue = []

            //     // 重新發送當前請求
            //     originalRequest.headers.Authorization = `Bearer ${newToken}`
            //     return service(originalRequest)

            // } catch (refreshError) {
            //     //刷新失敗處理 (跳轉至登錄)
            //     store.dispatch('logout')
            //     return Promise.reject(refreshError)
            // } finally {
            //     isRefreshing = false
            // }
        }
        return Promise.reject(error)
    }
)


export default service